import simg from '../images/service/img-1.jpg'
import simg2 from '../images/service/img-2.jpg'
import simg3 from '../images/service/img-3.jpg'
import simg4 from '../images/service/img-4.jpg'
import simg5 from '../images/service/img-5.jpg'
import simg6 from '../images/service/img-6.jpg'

import sIcon from '../images/service/1.png'
import svIcon2 from '../images/service/2.png'
import sIcon3 from '../images/service/3.png'
import svIcon3 from '../images/service/4.png'
import sIcon4 from '../images/service/5.png'
import svIcon4 from '../images/service/6.png'
import sIcon5 from '../images/service/7.png'
import svIcon5 from '../images/service/8.png'
import sIcon6 from '../images/service/9.png'
import svIcon6 from '../images/service/10.png'
import sIcon7 from '../images/service/11.png'
import svIcon7 from '../images/service/12.png'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'


import ins1 from '../images/instragram/14.jpg'
import ins2 from '../images/instragram/13.jpg'
import ins3 from '../images/instragram/15.jpg'
import ins4 from '../images/instragram/16.jpg'
import ins5 from '../images/instragram/17.jpg'
import ins6 from '../images/instragram/18.jpg'


const Services = [
    {
        Id: '1',
        sImg:simg,
        sTitle: '24/7 access',
        description:'Free yourself from time constraints. Help your child learn Arabic at his pace and according to your availability.',
        des2:'Free yourself from time constraints. Help your child learn Arabic at his pace and according to your availability.',
        icon:sIcon,
        icon2:svIcon2,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins1,
    },
    {
        Id: '2',
        sImg:simg2,
        sTitle: 'Tests & Quizzes',
        description:'Our Platform allows you to evaluate the learning progress of your child and elevate his skills throughout the course.',
        des2:'Our Platform allows you to evaluate the learning progress of your child and elevate his skills throughout the course.',
        icon:sIcon3,
        icon2:svIcon3,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins2,
    },
    {
        Id: '3',
        sImg:simg3,
        sTitle: 'Enjoyable Experience',
        description:'Our Platform allows your child to read stories, sing rhymes and songs and have fun while learning.',
        des2:'Our Platform allows your child to read stories, sing rhymes and songs and have fun while learning.',
        icon:sIcon4,
        icon2:svIcon4,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins3,
    },
    {
        Id: '4',
        sImg:simg4,
        sTitle: 'Interactive Learning',
        description:'Our Platform contains an interactive discussion forum that allows you to exchange with tutors and other learners.',
        des2:'Our Platform contains an interactive discussion forum that allows you to exchange with tutors and other learners.',
        icon:sIcon5,
        icon2:svIcon5,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins4,
    },
    {
        Id: '5',
        sImg:simg5,
        sTitle: 'Innovative Approach',
        description:'Our Platform uses an innovative interactive approach, throughout up-todate content and immersive experience.',
        des2:'Our Platform uses an innovative interactive approach, throughout up-todate content and immersive experience.',
        icon:sIcon6,
        icon2:svIcon6,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins5,
    },
    {
        Id: '6',
        sImg:simg6,
        sTitle: 'Qualified Teachers',
        description:'Your child will be accompanied by highly qualified teachers, native speakers with over 10 years of experience as teachers.',
        des2:'Your child will be accompanied by highly qualified teachers, native speakers with over 10 years of experience as teachers.',
        icon:sIcon7,
        icon2:svIcon7,
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    },
]
export default Services;